import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { DepositThresholdAction } from "./deposit-threshold.action";
import { DepositThresholdState } from "./deposit-threshold.model";

const INITIAL_STATE: DepositThresholdState = {
	hasReachedThreshold: false,
};

export const depositThresholdReducer = createReducer(
	INITIAL_STATE,
	on(DepositThresholdAction.fetchSuccess, (state, { hasReachedThreshold }) =>
		updateState(state, {
			hasReachedThreshold,
		})
	)
);
